import * as React from 'react';
import Box from '@material-ui/core/Box';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import CircleIcon from '@material-ui/icons/Lens';


export default function Stepper_component(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});


  if(activeStep>=props.steps.length){setActiveStep(0); return null;}
  const totalSteps = () => {
    return props.steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          props.steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  return (
    <Box sx={{ width: '100%' }}>
      <div style={{width:'100%', boxShadow:(props.quizz_stepper==true)?'rgb(0, 0, 0) 2px 2px 5px 2px':undefined}}>
      <Stepper variant='dots' nonLinear alternativeLabel activeStep={activeStep}>
        {props.steps.map((x, index) => (
          <Tooltip title={x.title}><Step key={x.title} completed={completed[index]}>
            <StepButton icon={(props.dots==true)?(props.steps[index].section_completed!=true)?(index==activeStep)?<CircleIcon color='primary'/>:<RadioButtonUncheckedIcon color={(index==activeStep)?'primary':undefined}/>:<CheckCircleOutlinedIcon color={undefined}/>:undefined} color="secondary" onClick={handleStep(index)}>
            </StepButton>
          </Step></Tooltip>
        ))}
      </Stepper>
      <Typography color='primary' style={{textAlign:'center', marginTop:'-20px', paddingBottom:'10px'}}>{props.steps[activeStep].title}</Typography>
      </div>
      <div>
        {allStepsCompleted() ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div style={{marginBottom:'25px', height:(props.height!=undefined)?props.height:'60vh', overflowY:'scroll'}}>{props.steps[activeStep].content}</div>
            <div style={{boxShadow:(props.quizz_stepper==true)?'rgb(136, 136, 136) 4px 8px 5px 10px':undefined, display:'flex', justifyContent:'center', alignItems:'center', width:'100%', paddingTop:'10px', paddingBottom:'12px', height:'37px', marginTop:'-25px'}}><Box sx={{ display: 'flex', flexDirection: 'row', pt: 2}}>
              {(props.steps.length<=1)?null:
                <React.Fragment><Button
                variant='contained'
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </Button>
              <Button color='primary' variant='contained' onClick={handleNext} sx={{ mr: 1 }} style={{marginLeft:'20px'}}>
                Next
              </Button></React.Fragment>}
            </Box></div>
          </React.Fragment>
        )}
      </div>
    </Box>
  );
}
